import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
import "../addtemplate/AddTemplate.css";
import { getCategoryNames } from "../../api/lib/templates";
import { addTemplate } from "../../api/lib/templates";

import Frame from "../../Images/Frame.svg";
import UploadIcon from "../../Images/upload-icon.svg";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifySuccess, notifyError } from "../../utils/helper";

const AddTemplate = () => {
  const history = useNavigate();
  const fileInputRef = useRef(null);
  const [templateData, setTemplateData] = useState({
    title: "",
    videoTemplate: "",
    category: "",
    suitableFor: "",
    description: "",
    id: "",
    isFree: false,
  });
  const [videoError, setVideoError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [suitableError, setSuitableError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [categories, setCategories] = useState([]);
  const [templateVideo, setTemplateVideo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  console.log(templateData);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["video/mp4", "video/webm", "video/ogg"];

    if (!file) {
      return;
    }

    if (allowedTypes.includes(file.type)) {
      const url = URL.createObjectURL(file);
      setTemplateVideo(url);
      setTemplateData((prev) => ({
        ...prev,
        videoTemplate: file,
      }));
      setVideoError("");
    } else {
      // Handle file type validation error
      setVideoError("Please select a valid video file (mp4, webm, ogg).");
    }
  };

  const postTemplateData = async (event, templateData) => {
    event.preventDefault();
    templateValidate(templateData);
    if (
      titleError ||
      videoError ||
      categoryError ||
      suitableError ||
      descriptionError
    ) {
      return;
    }
    try {
      setIsLoading(true);
      setUploadProgress(0);
      const catresponse = await getCategoryNames();
      const categoriesData = catresponse?.data?.data;

      const { _id } = categoriesData.find(
        (element) => element.name === templateData.category
      );

      if (_id) {
        templateData.id = _id;
        const response = await addTemplate(templateData, (progressEvent) => {
          if (progressEvent.total) {
            setUploadProgress(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }
        });

        if (response) {
          notifySuccess("Template Added Successfully");
          history("/video");
        }
      } else {
        alert("Category not Found");
      }
    } catch (error) {
      console.log("error", error);
      notifyError(
        error?.response?.data?.message || "Failed to Save the Template"
      );
    } finally {
      setIsLoading(false);
      setUploadProgress(0);
    }
  };

  const templateValidate = (templateData) => {
    const titleTrimmed = templateData.title.trim();

    if (!titleTrimmed || titleTrimmed.length < 2) {
      setTitleError("Title must be 2 characters long!");
    } else {
      setTitleError("");
    }

    if (!templateData.videoTemplate) {
      setVideoError("Video must be included!");
    } else {
      setVideoError("");
    }

    if (!templateData.category) {
      setCategoryError("Category is compulsory!");
    } else {
      setCategoryError("");
    }

    if (!templateData.suitableFor) {
      setSuitableError("Please Add the Age Group");
    } else {
      setSuitableError("");
    }

    if (!templateData.description) {
      setDescriptionError("Please add the Description");
    } else {
      setDescriptionError("");
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategoryNames();
        const categoriesData = data?.data.data;
        console.log(categoriesData, "categories-response");
        if (Array.isArray(categoriesData)) {
          setCategories(categoriesData);
        } else {
          console.log("Invalid category data:", categoriesData);
        }
      } catch (error) {
        console.log("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <div className="addtemplate-window">
        <div className="addtemplate-heading">Add Template</div>
        <hr className="addtemplate-hr" />
        <div className="addtemplate-body">
          <div className="addtemplate-upload">
            {templateVideo ? (
              <video
                src={templateVideo}
                controls
                className="addtemplate-videoupload"
              />
            ) : (
              <img
                src={Frame}
                alt=""
                className="addtemplate-imgupload"
                style={{ cursor: "pointer" }}
              />
            )}
            <div className="upload-wrapper">
              <button
                className="addtemplate-upload-btn"
                style={{ cursor: "pointer" }}
                onClick={handleButtonClick}
              >
                <div className="upload-text">Upload Video</div>
                <img src={UploadIcon} alt="" className="upload-icon" />
              </button>
              <p style={{ color: "red" }}>{videoError}</p>
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              accept="video/mp4, video/webm, video/ogg"
              id="select-video"
              ref={fileInputRef}
              onChange={(ev) => {
                handleFileSelect(ev);
              }}
            />
          </div>
          <div className="addtemplate-form-side">
            <form
              onSubmit={(ev) => postTemplateData(ev, templateData)}
              className="addtemplate-form"
            >
              <div className="form-wrap">
                <label htmlFor="" className="addtemplate-title">
                  Title
                </label>

                <input
                  type="text"
                  placeholder="Add Title"
                  className="addtemplate-titleinput"
                  maxLength={50}
                  onChange={(ev) =>
                    setTemplateData({ ...templateData, title: ev.target.value })
                  }
                />
                <p style={{ color: "red" }}>{titleError}</p>
              </div>
              <div className="form-wrap">
                <label htmlFor="" className="addtemplate-category">
                  Category
                </label>
                <select
                  className="addtemplate-categoryinput"
                  onChange={(ev) =>
                    setTemplateData({
                      ...templateData,
                      category: ev.target.value,
                    })
                  }
                >
                  <option value="">Select a category</option>
                  {categories.map((category) => (
                    <option value={category.name} key={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                <p style={{ color: "red" }}>{categoryError}</p>
              </div>
              <div className="form-wrap">
                <label htmlFor="" className="addtemplate-suitaiblity">
                  Suitable For
                </label>

                <input
                  type="text"
                  placeholder="0-5 Year Old"
                  className="addtemplate-suitable-input"
                  onChange={(ev) =>
                    setTemplateData({
                      ...templateData,
                      suitableFor: ev.target.value,
                    })
                  }
                />
                <p style={{ color: "red" }}>{suitableError}</p>
              </div>
              <div className="form-wrap">
                <label htmlFor="" className="addtemplate-description">
                  Description
                </label>

                <textarea
                  type="text"
                  placeholder="Add Description"
                  value={templateData.description}
                  maxLength={100}
                  className="addtemplate-description-inp"
                  onChange={(ev) =>
                    setTemplateData({
                      ...templateData,
                      description: ev.target.value,
                    })
                  }
                />
                <p style={{ color: "red" }}>{descriptionError}</p>
              </div>
              <div className="form-wrap">
                <label
                  className="addtemplate-title"
                  style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
                >
                  <input
                    type="checkbox"
                    checked={templateData.isFree}
                    onChange={(ev) =>
                      setTemplateData({
                        ...templateData,
                        isFree: ev.target.checked,
                      })
                    }
                  />
                  Free tier (available without a subscription)
                </label>
              </div>
              {isLoading && (
                <div className="form-wrap">
                  <div
                    style={{
                      width: "100%",
                      height: "8px",
                      background: "#e5e5e5",
                      borderRadius: "4px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${uploadProgress}%`,
                        height: "100%",
                        background: "#2f9e8f",
                        transition: "width 0.2s ease",
                      }}
                    />
                  </div>
                  <p style={{ margin: "4px 0 0" }}>
                    {uploadProgress < 100
                      ? `Uploading video... ${uploadProgress}%`
                      : "Upload complete — processing video, this can take a few minutes for large files..."}
                  </p>
                </div>
              )}
              <div className="addtemplate-btn">
                <button
                  type="submit"
                  style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
                  className="addtemplate-savebtn"
                  disabled={isLoading}
                >
                  {isLoading
                    ? uploadProgress < 100
                      ? `Uploading ${uploadProgress}%`
                      : "Processing..."
                    : "Save"}
                </button>
                <button
                  onClick={() => history("/video")}
                  style={{ cursor: "pointer" }}
                  className="addtemplate-cancelbtn"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export default AddTemplate;
